import Api from '../api';

function update() {
  return new Promise(async function (resolve, reject) {
    let c = await Api.checkLogin();

    if (c.data.response.status == 200) {
      resolve(true);
    } else {
      resolve(false);
    }
  });
}

const CheckToken = (token) => {
  if (token !== 'undefined' && token !== undefined) {
    return true;
  } else {
    return false;
  }
};
export default CheckToken;
